(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('FlyerCategorysEditController', FlyerCategorysEditController);

    FlyerCategorysEditController.$inject = ['$timeout', '$localStorage', '$state', '$scope', '$stateParams', '$translate', '$uibModalInstance', 'FlyerCategoryService', 'toastr', 'category'];

    function FlyerCategorysEditController($timeout, $localStorage, $state, $scope, $stateParams, $translate, $uibModalInstance, FlyerCategoryService, toastr, category) {
        var vm = this;
        vm.save = save;
        vm.clear = clear;
        vm.category = category;

        function save() {
          FlyerCategoryService.updateCategory(vm.category).then(function (data) {
            toastr.success($translate.instant('categorys.messages.edit.success'));
            $uibModalInstance.close(true);
          }, function (data) {
            toastr.error($translate.instant('categorys.messages.edit.error'));
          });
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

    }

})();
